import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "mobile_filters--container q-pt-3 q-border-top"
}

import {inject, watch, computed} from "vue";
import FiltersListContainer from '@/components/SerpPage/FiltersContainer/FiltersList/FiltersListContainer.vue'
import FiltersHeaderContainer from '@/components/SerpPage/FiltersContainer/Header/FiltersHeaderContainer.vue'
import CloseButton from "@/components/SerpPage/FiltersContainer/Header/CloseButton.vue";
import AppendFiltersButton from "@/components/SerpPage/ResultsContainer/ButtonsContainer/AppendFiltersButton.vue";
import ComponentLoader from '@/components/ComponentLoader.vue'


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {SmartSearchConfigInterface} from "@/core/types";
import {storeToRefs} from "pinia";
import ClearFiltersButtonMobile
  from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButtonMobile.vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import LinearLoader from "@/components/LinearLoader.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersContainer',
  setup(__props) {

const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore()
const {canShowFiltersOnMobile, isLoading, getFiltersLength} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {allowEmptyQuery} = SmartSearchConfig.value.serp.query


const {query, loading: productIsLoading} = storeToRefs(serpStore)
const hasLoadedFilters = computed(() => getFiltersLength.value > 0)
const shouldBlockFiltersUi = computed(() => isLoading.value && !hasLoadedFilters.value)
const shouldShowMobileLinearLoader = computed(() => {
  if (!hasLoadedFilters.value) {
    return isLoading.value || (productIsLoading.value && isMobileView.value)
  }

  return productIsLoading.value && isMobileView.value
})
const typeQueryState = computed(() => {
  return !productIsLoading.value && !allowEmptyQuery && !query.value
})
watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});


return (_ctx: any,_cache: any) => {
  return (!_unref(isTabletView))
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "filters-container",
        class: _normalizeClass([{
       'q-d-block ': _unref(canShowFiltersOnMobile),
       'q-d-none': !_unref(canShowFiltersOnMobile),
       'serp__filters--mobile  q-slide-in-left q-position-fixed q-top-0 q-left-0 q-bottom-0 q-right-0 q-w-100 q-h-100 ': _unref(canShowFiltersOnMobile) && _unref(isMobileView)
       }, "serp__filters-container q-col-md-4 q-col-lg-3 q-col-sm-12 q-d-lg-block q-py-3 q-py-md-1 q-position-relative q-bg-light"])
      }, [
        _createVNode(ComponentLoader, {
          loading: _unref(isLoading) || (_unref(productIsLoading) && _unref(isMobileView))
        }, null, 8, ["loading"]),
        (_unref(isMobileView))
          ? (_openBlock(), _createBlock(CloseButton, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(isMobileView))
          ? (_openBlock(), _createBlock(FiltersHeaderContainer, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(FiltersListContainer),
        (_unref(isMobileView))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(LinearLoader, { loading: shouldShowMobileLinearLoader.value }, null, 8, ["loading"]),
              _createVNode(AppendFiltersButton),
              (_unref(isMobileView))
                ? (_openBlock(), _createBlock(ClearFiltersButtonMobile, { key: 0 }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2)), [
        [_vShow, _unref(getFiltersLength) && !typeQueryState.value]
      ])
    : _createCommentVNode("", true)
}
}

})